// extracted by mini-css-extract-plugin
export default {"span":"navBar_span__Tr7FA","burger":"navBar_burger__XD0qB","burgerDiv":"navBar_burgerDiv__Roob4","navLinksFade":"navBar_navLinksFade__w3RjK"};